// 2. EditFeatureCategory.jsx - Updated with proper update buttons
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BackButton } from "../../common/GeneralComponent";
import Loader from "../../../components/partials/Loader";
import { fetchData } from "../../../utils/functions";
import { useDispatch } from "react-redux";
import FeatureCategoryInfo from "./FeatureCategoryInfo";
import FeatureDesign from "./FeatureDesign";
import CriticalStages from "./CriticalStages";

const EditFeatureCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const scrollRef = useRef(null);

  const [loader, setLoader] = useState(true);
  const [isLeftClicked, setIsLeftClicked] = useState(false);
  const [isRightClicked, setIsRightClicked] = useState(false);
  const [categoryData, setCategoryData] = useState(null);

  const tabs = ["Feature Category", "Feature Design", "Critical Stages"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const scrollTabs = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });

      if (direction === "left") {
        setIsLeftClicked(true);
        setTimeout(() => setIsLeftClicked(false), 200);
      } else {
        setIsRightClicked(true);
        setTimeout(() => setIsRightClicked(false), 200);
      }
    }
  };

  const fetchCategoryData = async () => {
    try {
      setLoader(true);
      const res = await fetchData(
        `feature-category/${id}`,
        "GET",
        null,
        {},
        {},
        navigate
      );
      if (res?.data) {
        setCategoryData(res.data);
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, [id]);

  if (loader) {
    return <Loader />;
  }

  return (
    <div className="w-full my-4 mx-auto">
      <div className="flex lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
          Edit Feature Category
        </h1>
        <BackButton text="Back" to="/feature-category-view" />
      </div>

      <div className="mt-6">
        <div className="flex items-center rounded-t-lg rounded-tr-lg bg-[#fdf5ec] relative">
          <button
            onClick={() => scrollTabs("left")}
            className={`text-xl px-4 py-2 font-bold rounded-lg transition-colors ${
              isLeftClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            «
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-hidden scrollbar-hide"
          >
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-10 py-2 font-semibold whitespace-nowrap ${
                  activeTab === tab ? "bg-[#caa316] text-white" : "text-black"
                }`}
                style={{
                  borderTopLeftRadius: "13px",
                  borderTopRightRadius: "30px",
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollTabs("right")}
            className={`ml-auto text-xl px-4 py-2 rounded-lg font-bold transition-colors ${
              isRightClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            »
          </button>
        </div>

        <div className="bg-white rounded-b-lg rounded-br-lg shadow-md p-6">
          {activeTab === "Feature Category" && (
            <FeatureCategoryInfo
              categoryId={id}
              categoryData={categoryData}
              onCategoryUpdated={() => fetchCategoryData()}
              isEditMode={true}
              showUpdateOnly={true}
            />
          )}

          {activeTab === "Feature Design" && (
            <FeatureDesign
              featureCategoryId={id}
              isEditMode={true}
              showUpdateOnly={true}
            />
          )}

          {activeTab === "Critical Stages" && (
            <CriticalStages
              featureCategoryId={id}
              isEditMode={true}
              showUpdateOnly={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EditFeatureCategory;
